import { AppTable, AppTableColumn } from 'src/app/shared/_models/models';
import {
  AlertsConfig,
  AlertsTable,
  EXCHANGE_DEALS_EXTERNAL_ALERTS_SENTINEL_GROUP
} from '../types';
import { of } from 'rxjs';

const authPermissions = {
  canRead: true,
  canCreate: true,
  canUpdate: true,
  canDelete: true,
};

const alertsTable = new AppTable('exchangeDealsExternalAlertsTable', 1, 10, 'description', 'asc', false, false, 'no-border');

export const exchangeDealsExternalAlertsTableColumns: AppTableColumn[] = [
  { id: 'alertName', prop: 'name', displayName: 'Notification Type', type: 'text' },
  { id: 'emailAlert', prop: 'type', displayName: 'Email Me', type: 'toggle', actionId: EXCHANGE_DEALS_EXTERNAL_ALERTS_SENTINEL_GROUP },
];

export const exchangeDealsExternalAlertsTable: AlertsTable = {
  group: EXCHANGE_DEALS_EXTERNAL_ALERTS_SENTINEL_GROUP,
  title: null,
  hasFooter: false,
  table: alertsTable,
  tableColumns: exchangeDealsExternalAlertsTableColumns,
  authUser: authPermissions,
  isLoading: true,
  tableRows$: of([]),
};

export const exchangeDealsExternalAlertsConfig: AlertsConfig = {
  alertsTable: exchangeDealsExternalAlertsTable,
};
